import { IdentifiableObject } from '@data/common/IdentifiableObject';
import { Transform, Type } from 'class-transformer';
import { DateUtil } from '@shared/util/date.util';
import { ImageDTO } from '@data/common/ImageDTO';

export class PatientNoteDTO extends IdentifiableObject {
  @Transform(DateUtil.dateConversion)
  public date: Date;

  @Type(() => ImageDTO)
  images?: ImageDTO[];

  text: string;
}
